.link {
  display: inline-flex;
  flex-shrink: 0;
  border-radius: 9999px;
}

/* Holds the chip's place, invisible, until its state loads. */
.pending {
  display: inline-flex;
  flex-shrink: 0;
  visibility: hidden;
}

.fadeIn {
  animation: fade-in 200ms ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .fadeIn {
    animation: none;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
